import { IRetailerUserNotificationCount } from "@faire/web-api/indigofair/retailer/IRetailerUserNotificationCount";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const getRetailerUserNotificationCount = ():
  | IRetailerUserNotificationCount
  | undefined => getGlobalProperty("retailerUserNotificationCount");
